const apiUrl = process.env.REACT_APP_API_URL;
export const fetchActivities = (lang) => {
  return async (dispatch) => {
    dispatch({ type: 'FETCH_ACTIVITIES_REQUEST' });

    try {
      const res = await fetch(`${apiUrl}/api/activities?lang=${lang}`);
      const data = await res.json();
      dispatch({ type: 'FETCH_ACTIVITIES_SUCCESS', payload: data });
    } catch (err) {
      dispatch({ type: 'FETCH_ACTIVITIES_FAILURE', payload: err.message });
    }
  };
};
